import React, { useRef } from 'react';
import queryString from 'query-string';
import Pagination from '@/components/pagination/Pagination';
import useScrollToTop from '@/hooks/useScrollToTop';
import Results from './Results';
import PaginationInformation from '@/components/pagination/PaginationInformation';
import DistanceFilter from './DistanceFilter';
import FilterButton from './FilterButton';
import useQuery from './useQuery';
import useFilterCount from '@/hooks/useFilterCount';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { attributeKeys } from './queryUtils';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ShareProjectCallout from '@/features/share-project/components/ShareProjectCallout';
import ShareEventCallout from '@/features/share-event/components/ShareEventCallout';

Partners.propTypes = {
  project: PropTypes.shape({}),
  event: PropTypes.shape({}),
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired
  }).isRequired,
  distance: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default function Partners(props) {
  const { project, event, router, distance } = props;

  const { location } = router;
  const scrollToTop = useScrollToTop();

  const search = queryString.parse(location.search);
  const filterCount = useFilterCount(search, _.filter(attributeKeys, key => [
    'locationCondition'
  ].indexOf(key) < 0));

  const node = useRef();

  const pageSize = 16;

  const result = useQuery({
    search,
    pageSize,
    distance
  });

  const launch = useDialogLauncher();
  const config = useDialogConfig();

  function showFilters() {
    launch(DialogManager.FiltersPartner.Config(config?.id));
  }

  // Only when browsing partners for a project from within the project dialog;
  // ShareProjectCallout further hides itself while the project has missing fields.
  const showShare = Boolean(project && config?.type === 'project_manage');
  // Same for events; ShareEventCallout hides itself while the event has missing fields.
  const showShareEvent = Boolean(event && config?.type === 'event_manage');

  return (
    <>
      {showShare && (
        <ShareProjectCallout project={project} />
      )}
      {showShareEvent && (
        <ShareEventCallout event={event} />
      )}
      <div ref={node} className="flex flex-col sm:flex-row flex-wrap gap-4 justify-between">
        <div className="flex flex-col sm:flex-row gap-4">
          <DistanceFilter />
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          {/*<SortBy withDistance={!!distance} />*/}
          <FilterButton
            count={filterCount}
            onClick={showFilters}
          />
        </div>
      </div>
      <Results
        project={project}
        event={event}
        result={result}
      />
      <div className="flex items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
        <Pagination
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
          onNavigate={() => scrollToTop(node)}
        />
      </div>
    </>
  );
}
